module.exports = __webpack_public_path__ + "/bundle/asset/admission1-2-10c8b46b3458a79225f1543badb06078.png";